import isNil from 'lodash/isNil';

export function hueToRgb(p, q, t) {
  if (t < 0) { t += 1; }
  if (t > 1) { t -= 1; }
  if (t < 1 / 6) { return p + (q - p) * 6 * t; }
  if (t < 1 / 2) { return q; }
  if (t < 2 / 3) { return p + (q - p) * (2 / 3 - t) * 6; }
  return p;
}

export function getDistinctColor(step, totalSteps = 12, saturation = 60, lightness = 60) {
  const hueStep = 360 / totalSteps;
  const hue = step * hueStep;

  // Convert HSL to RGB
  const h = hue / 360;
  const s = saturation / 100;
  const l = lightness / 100;

  // Calculate RGB components
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hueToRgb(p, q, h + 1 / 3);
  const g = hueToRgb(p, q, h);
  const b = hueToRgb(p, q, h - 1 / 3);

  // Convert RGB to hex
  const rgbToHex = (c) => Math.round(c * 255).toString(16).padStart(2, '0');
  const hexColor = `#${rgbToHex(r)}${rgbToHex(g)}${rgbToHex(b)}`;

  return hexColor;
}

// Colours handler move from ui-components
const toHex = (value) => {
  const hexadecimal = value.toString(16);
  return hexadecimal.length === 1 ? `0${hexadecimal}` : hexadecimal;
};

export const convertRGBtoHex = (rgbValue = 'rgba(0, 0, 0, 1)') => {
  const [red, green, blue] = rgbValue
    .replace('rgba(', '')
    .replace('rgb(', '')
    .replace(')', '')
    .split(', ')
    .map((n) => parseInt(n, 10));
  return `#${toHex(red)}${toHex(green)}${toHex(blue)}`;
};

const getRGB = (value) => {
  const hex = value ?? '#000000';
  const r = parseInt(hex[1] + hex[2], 16);
  const g = parseInt(hex[3] + hex[4], 16);
  const b = parseInt(hex[5] + hex[6], 16);
  return { r, g, b };
};

export const convertHexToRGB = (colorHex, opacity = 1) => {
  if (isNil(colorHex)) {
    return colorHex;
  }
  const { r, g, b } = getRGB(colorHex);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

const rgbToYIQ = ({ r, g, b }) => (((r * 299) + (g * 587) + (b * 114)) / 1000);

export const getContrastColor = (colorHex, threshold = 128) => {
  if (isNil(colorHex)) {
    return '#000000';
  }
  const rgb = getRGB(colorHex);

  if (isNil(rgb)) {
    return '#000000';
  }

  return rgbToYIQ(rgb) >= threshold ? '#000000' : '#ffffff';
};
